import {
    HttpResponse,
    StationModel,
    QueryModel,
    RequestParams,
    StationModelIEnumerableApiResultSuccess,
    StationModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";
import {CrudPartialUpdatePatch} from '@/libs/core/+state/models/crud-partial-update-patch';

export class StationsDataService implements CrudService<StationModel, StationModel> {
    getAll(query: CrudDataQuery<StationModel>): Promise<CrudEnumerableResponse<StationModel>> {
        return ApiService.api.getStationBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<StationModel>): Promise<CrudEnumerableResponse<StationModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<StationModel>> {
        return ApiService.api.getStationById(id, params);
    }

    create(item: StationModel, params?: RequestParams): Promise<CrudResponse<StationModel>> {
        return ApiService.api.insertStation(item, params);
    }

    update(item: StationModel, params?: RequestParams): Promise<StationModel> {
        return ApiService.api.updateStation(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<StationModel> {
        return ApiService.api.patchStation(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<StationModel>): Promise<CrudEnumerableResponse<StationModel>> {
        return ApiService.api.deleteStations(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationStation(query, params).then((req: any) => req.data.returnValue);
    }
    
    download(query: CrudDataQuery<StationModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: StationModel, params?: RequestParams): Promise<CrudResponse<StationModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getStationGroupped(query, params);
    }

}
